var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NoDataFound"},[_c('div',{staticClass:"text-center no-data-container"},[_vm._v("\n    "+_vm._s(_vm.noDataContent && _vm.noDataContent.length ? _vm.noDataContent : 'No data available')+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }